import { isEmpty } from 'lodash';
import { Dispatch } from 'react';
import { apiBaseUrl, networkCall } from '../../utils/networkCall';

export const APPLY_SENDER_ID: string = "APPLY_SENDER_ID";
export const GET_DATA: string = "GET_DATA";
export const GET_DATA_BY_ID: string = "GET_DATA_BY_ID";
export const GET_SENDER_ID_DETAILS_LOADING: string = "GET_SENDER_ID_DETAILS_LOADING";
export const DELETE_SMS_IDS: string = "DELETE_SMS_IDS";

export function addSMSTemplate(templateId: string, channelId: number, name: string, status: number): IAddSMSTemplateActionType {
    return { type: APPLY_SENDER_ID, templateId: templateId, channelId: channelId, name: name, status: status }
}

export function deleteSenderIds(senderIds:string[], sender_name: string[]): IDeleteSenderIds {
    return {type: DELETE_SMS_IDS, payload: {ids: senderIds, names: sender_name}}
}

interface IAddSMSTemplateActionType { type: string, templateId: string, channelId: number, name: string, status: number }

interface IDeleteSenderIds {
    type: string, 
    payload: {
        ids:string[],
        names:string[]
    },
}

export const getData = () => {
    return (dispatch: Dispatch<any>) => {
        networkCall("get", `/messages/configuration/sender`, apiBaseUrl.baseUrl)
            .then((res: any) => {
                if (isEmpty(res.error)) {
                    dispatch({ type: GET_DATA, payload: res });
                }
            }).catch((error) => {
                if (error?.response?.data) {
                    console.log(error.response)
                }
            });
    }
}

export const getDataById = (id: any) => {
    return (dispatch: Dispatch<any>) => {
        dispatch({ type: GET_SENDER_ID_DETAILS_LOADING});
        networkCall("get", `/messages/configuration/sender/${id}`, apiBaseUrl.baseUrl)
            .then((res: any) => {
                if (isEmpty(res.error)) {
                    dispatch({ type: GET_DATA_BY_ID, payload: res });
                }
            }).catch((error) => {
                if (error?.response?.data) {
                    console.log(error.response)
                }
            });
    }
}

export const docUpload = (
    data: any,
    cb: (data: any, uuid?: string) => void,
    onError: () => void,
    uuid: string = '',
) => {
    return () => {
        let url: string = `/documents`;
        networkCall('post', url, apiBaseUrl.baseUrl, true, true, data)
            .then((res: any) => {
                cb(res, uuid);
            }).catch(() => {
                onError();
            });
    };
};

export const getvSMSEnableRoutes = (cb: (data: any, flag: boolean) => void) => {
    return () => {
        let url: string = `/SMS-routes`;
        networkCall('get', url, apiBaseUrl.baseUrl, true, true)
            .then((res: any) => {
                cb(res, true);
            }).catch(() => {
                cb({}, false)
            });
    }
}

export const deleteSender = (data: any, cb: any) => {
    return () => {
        networkCall("delete", `/messages/configuration/sender`, apiBaseUrl.baseUrl, true, true, data)
            .then((res: any) => {
                if (!isEmpty(res.data.error)) {
                    cb(res, false)
                } else {
                    cb(res, true)
                }
            }).catch((error) => {
                if (error?.response?.data) {
                    cb(error, false)
                    console.log(error.response)
                }
            });
    }
}